import { PayloadAction } from '../../../store.model';
import { ActionType } from '../search.action';
import { defaultState, SearchState } from '../search.state';

import { Reset } from './reset.action';

export function resetReducer(
    state: SearchState,
    _: PayloadAction<ActionType.EVAL_SEARCH__RESET, Reset>,
): SearchState {
    return defaultState();
}
